import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { RoleType } from '@enums/role-type.enums';
import { noScriptValidator } from 'src/app/shared/validators/no-script-validator';

@Component({
  selector: 'app-no-signin-watch-video',
  imports: [ReactiveFormsModule, MatCardModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule],
  templateUrl: './no-signin-watch-video.component.html',
  styleUrl: './no-signin-watch-video.component.scss',
})
export class NoSignInWatchVideoComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);

  // Name validators (firstName, lastName)
  private nameValidators = [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(100),
    Validators.pattern(/^[a-zA-Z\s'-]+$/),
    noScriptValidator,
  ];

  // Company validator
  private companyValidators = [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(100),
    Validators.pattern(/^[a-zA-Z0-9\s&.,'-]+$/),
    noScriptValidator,
  ];

  // Email validator
  private emailValidators = [Validators.required, Validators.email, Validators.maxLength(100), noScriptValidator];

  form: FormGroup = this.fb.group({
    firstName: ['', this.nameValidators],
    lastName: ['', this.nameValidators],
    email: ['', this.emailValidators],
    company: ['Unknown', this.companyValidators],
    title: [RoleType.UNKNOWN, Validators.required],
  });

  roleTypes = Object.values(RoleType).filter((role) => role !== RoleType.AGENT && role !== RoleType.EMPLOYEE);

  onSubmit(): void {
    if (this.form.valid) {
      const userData = {
        firstName: this.form.value.firstName.trim(),
        lastName: this.form.value.lastName.trim(),
        email: this.form.value.email.trim(),
        company: this.form.value.company.trim(),
        title: this.form.value.title,
      };

      sessionStorage.setItem('temp_user_data', JSON.stringify(userData));
      this.router.navigate(['/video']);
    }
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }
}
